export const BACKEND_URL = "https://media.scoreplay.io";
export const BACKEND_API_URL = BACKEND_URL + "/api";
export const FAN_URL = "https://api.scoreplay.fan";
export const FAN_API_URL = FAN_URL + "/api";
export const ANALYTICS_URL = "https://analytics.scoreplay.io";

export const getShareableLink = (id: number | string, token: string) =>
  BACKEND_URL + `/mkpl/media/search/${id}?token=${token}&per_page=2000&page=1`;

export const colors = {
  button_base: "#2F313F",
  background: "#F1F3F4",
  table_variant: "#f8f8f8",
  white: "#FFFFFF",
  black: "#000000",
  event_tag: "#2F313F",
  red_strong: "#F64E60",
  red_mild: "#FFE2E5",
  green_strong: "#03783a",
  green_mild: "#C9F7F5",
  purple_strong: "#460bbb",
  purple_mild: "#EEE5FF",
  yellow_strong: "#FFA800",
  yellow_mild: "#FFF4DE",
  blue_strong: "#4CA8C9",
  blue_mild: "#CEE7F0",
  input_mild: "#F1F3F4",
  primary: "#4CA8C9",
  secondary: "#3F0E40",
  primary_text: "#2F313F",
  secondary_text: "#526476",
  disabled: "#A7A7A7",
  placeholder: "#A7A7A7",
  success: "#008000",
  player: "#074829",
  partner: "#3F0E40",
  tag: "#0E1C40",
  favorite: "#FFC400",
  favorite_mild: "#FFF7DC",
  grey_mild: "#eef0fe",
  upload_active: "#00e676",
};
